import loader from './loader/index.js';
export { default } from './loader/index.js';
